import React from 'react';
import sclColumns from '../../Forms/locations/columns';
import stakeholderColumns from '../../Forms/stakeholder/columns';
import eventsColumns from '../../Forms/events/columns';
import lirColumns from '../../Forms/lir/columns';
import { NavLink } from 'react-router-dom';

export const emptyDataSource = [
  { projectId: 1, empty: true },
  { projectId: 2, empty: true },
  { projectId: 3, empty: true },
  { projectId: 4, empty: true },
  { projectId: 5, empty: true },
  { projectId: 6, empty: true },
  { projectId: 7, empty: true },
  { projectId: 8, empty: true },
  { projectId: 9, empty: true },
  { projectId: 10, empty: true },
]

const columns = [
  {
    title: "Locations",
    call: "sclsGet",
    state: "locations",
    entity: "location",
    columns: sclColumns,
    modules: ['cadd', 'pme', 'tif'],
    component: 'newTable',
  },
  {
    title: "Stakeholders",
    call: "stakeholdersGet",
    state: "stakeholders",
    entity: "stakeholder",
    columns: stakeholderColumns,
    modules: ['cadd', 'pme', 'tif'],
    component: 'newTable',
  },
  {
    title: "Events",
    call: "eventsGet",
    state: "events",
    component: 'newTable',
    entity: "event",
    columns: eventsColumns,
    modules: ['cadd', 'pme', 'tif']
  },
  {
    title: "LIR",
    call: "lirGet",
    state: "lir",
    entity: "lir",
    columns: lirColumns,
    modules: ['pme', 'cadd', 'tif'],
    component: 'newTable',
  },
  {
    title: ('Due Diligence'),
    call: 'reportingGet',
    state: 'dueDiligence',
    entity: 'dueDiligence',
    columns: (t, module) => [
      {
        title: t('ID'),
        dataIndex: 'id',
        key: 'id',
        show: true,
        width: '25%',
        primarySearch: true,
      },
      {
        title: t('Document name'),
        width: '25%',
        dataIndex: 'name',
        key: 'name',
        show: true,
        primarySearch: true,
        render: (name, item) => {
          return <NavLink className="projectLink" target="_blank" to={`/app/${module}/view/${item.id}/user`}>
            {t(name)}
          </NavLink>
        }
      },
      {
        title: t('Last Updated'),
        width: '25%',
        dataIndex: 'lastUpdated',
        key: 'lastUpdated',
        show: true,
      },
      {
        title: t('Version'),
        width: '25%',
        dataIndex: 'version',
        key: 'version',
        show: false,
        publication: true,
        sorter: (a, b) => parseInt(a) > parseInt(b),
      },
    ],
    modules: ['cadd', 'pme', 'tif']
  },
];

export default columns;
